import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  vendor_id: Yup.string()
    .nullable()
    .required("Vendor is required."),
});
